import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { token, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center',
                    minHeight:'100vh', fontSize:15, color:'#aaa' }}>
        Loading…
      </div>
    );
  }

  return token ? children : <Navigate to="/vendor/login" replace />;
}
